@if (overlay) {
  <div class="overlay">
    <div class="center">
      <ng-template [ngTemplateOutlet]="progressSpinner"></ng-template>
    </div>
  </div>
} @else {
  <mat-spinner
    [diameter]="diameter"
    [mode]="mode"
    [strokeWidth]="strokeWidth"
    [value]="value"
    [ngClass]="{ 'overlay-spinner': true }">
  </mat-spinner>
}
<ng-template #progressSpinner>
  <mat-spinner
    [diameter]="diameter"
    [mode]="mode"
    [strokeWidth]="strokeWidth"
    [value]="value"
    [ngClass]="{ 'overlay-spinner': true }">
  </mat-spinner>
</ng-template>

